<template>
    <div id="redirectDiv">
    </div>
</template>

<script>
export default {
  name: 'Redirect',
  components: {
  },
  beforeCreate () {
    document.title = this.$route.params.data+' - Labotist'
  },
  data () {
    return {}
  },
  mounted () {
      setTimeout(function() {
          if (this.$route.params.tests) {
            this.$router.push({ path: '/redirect/labs/'+this.$route.params.tests })
            //   wind   ow.location = this.$route.params.tests;
          } else {
              this.$router.push({ path: '/' })
          }
          this.$hidePageLoading()
      }.bind(this), 500)
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/web/Public/Redirect.vue